import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { useState, useLayoutEffect, useRef } from 'react'
import PageLink from '../PageLink'
import './styles.scss'

const CaseTeaser = ({ index, client, description, to, backgroundColor, desktopImage, mobileImage, layout }) => {
  const [descriptionHeight, setDescriptionHeight] = useState(0)
  const descriptionRef = useRef(null)

  useLayoutEffect(() => {
    setDescriptionHeight(descriptionRef.current?.clientHeight ?? 0)
  })

  return (
    <div
      className={cx({
        'case-teaser': true,
        [`case-teaser--index-${index}`]: index
      })}
    >
      <PageLink to={to} display="block" state={{ origin: 'frontpage' }}>
        <div className="case-teaser__inner" style={{ '--backgroundColor': backgroundColor }}>
          <div className="case-teaser__meta">
            <div className="case-teaser__meta__title">{client}</div>
            <div ref={descriptionRef} className="case-teaser__meta__description">
              {description}
            </div>
          </div>
          <div
            className={cx({
              'case-teaser__layout': true,
              [`case-teaser__layout--${layout}`]: layout
            })}
            style={{ '--description-height': `${descriptionHeight}px` }}
          >
            <div className="case-teaser__layout__screen case-teaser__layout__screen--desktop">
              <div className="case-teaser__layout__screen__frame case-teaser__layout__screen__frame--desktop">
                {desktopImage}
              </div>
            </div>
            <div className="case-teaser__layout__screen case-teaser__layout__screen--mobile" layout={layout}>
              <div className="case-teaser__layout__screen__frame case-teaser__layout__screen__frame--mobile">
                {mobileImage}
              </div>
            </div>
          </div>
        </div>
      </PageLink>
    </div>
  )
}

CaseTeaser.propTypes = {
  index: PropTypes.number,
  client: PropTypes.string,
  description: PropTypes.string,
  to: PropTypes.string,
  backgroundColor: PropTypes.string,
  desktopImage: PropTypes.element,
  mobileImage: PropTypes.element,
  layout: PropTypes.oneOf([1, 2, 3, 4])
}

export default CaseTeaser
